<template>
  <component :is="stockregistryData === undefined ? 'div' : 'b-card'">
    <!-- Alert: No Stockregistry found -->
    <b-alert variant="danger" :show="stockregistryData === undefined">
      <h4 class="alert-heading">Erreur lors de chargement du contenu</h4>
      <div class="alert-body">
        Aucun element trouvé avec cet identifiant. Vérifier
        <b-link class="alert-link" :to="{ name: 'stockregistry-list' }">
          Liste des elements
        </b-link>
        pour les autres element.
      </div>
    </b-alert>

    <data-add-tab
      :stockregistry-data="stockregistryData"
      :defaultstockregistry-data="defaultstockregistryData"
      class="mt-2"
    />
  </component>
</template>

<script>
import {
  BTab,
  BTabs,
  BCard,
  BRow,
  BCol,
  BAlert,
  BLink,
  BFormCheckbox,
  BButton,
} from "bootstrap-vue";
import { ref, onUnmounted } from "@vue/composition-api";
import router from "@/router";
import store from "@/store";
import storeModule from "./storeModule";
import DataAddTab from "./FormData.vue";
import Ripple from "vue-ripple-directive";

export default {
  components: {
    BTab,
    BTabs,
    BCard,
    BRow,
    BCol,
    BAlert,
    BLink,
    BFormCheckbox,
    DataAddTab,
    BButton,
    // DataAddTabInformation,
    // DataAddTabSocial,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      operationTitle: "",
      operationIcon: "",
    };
  },
  mounted() {
    if (router.currentRoute.name == "stockregistry-add-new") {
      this.operationTitle = "Ajouter Stockregistry";
      this.operationIcon = "AddIcon";
    }
    if (router.currentRoute.name == "stockregistry-view") {
      this.operationTitle = "Détails de l'Stockregistry";
      this.operationIcon = "EyeIcon";
    }
    if (router.currentRoute.name == "stockregistry-edit") {
      this.operationTitle = "Modification de l'Stockregistry";
      this.operationIcon = "EditIcon";
    }
  },
  methods: {
    prevPage() {
      router.push({ name: "stockregistry-list" });
    },
    convertBoolToInt(value) {
      if (value == 1) {
        return true;
      } else {
        return false;
      }
    },
  },
  setup() {
    let stockregistryData = ref(null);
    let APP_STORE_MODULE_NAME = "app-stockregistry";

    // Register module
    if (!store.hasModule(APP_STORE_MODULE_NAME))
      store.registerModule(APP_STORE_MODULE_NAME, storeModule);

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(APP_STORE_MODULE_NAME))
        store.unregisterModule(APP_STORE_MODULE_NAME);
    });

    var defaultstockregistryData = ref({
      budjet: "",
      date: "", 
      notes: "", 
    }); 

    if (router.currentRoute.name == "stockregistry-add-new") {
      // init empty stockregistry data
      stockregistryData = defaultstockregistryData;
    } else {
      // requirement //
      store
        .dispatch(APP_STORE_MODULE_NAME + "/fetchModule", {
          id: router.currentRoute.params.id,
        })
        .then((response) => {
          stockregistryData.value = response.data;
        })
        .catch((error) => {
          console.log(error);
          stockregistryData.value = undefined;
        });
    }

    return {
      stockregistryData,
      defaultstockregistryData,
    };
  },
};
</script>
